<section class="purchase-sec wow animated fadeInUp animated" [ngClass]="quote.background">
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <span>{{ quote.quote }}</span>
      </div>
    </div>
  </div>
</section>
<!--cta-->
